export var KibanaQuickTimeToday;
(function (KibanaQuickTimeToday) {
    KibanaQuickTimeToday["Mode"] = "quick";
    KibanaQuickTimeToday["From"] = "now/d";
    KibanaQuickTimeToday["To"] = "now/d";
})(KibanaQuickTimeToday || (KibanaQuickTimeToday = {}));
export var KibanaSubjects;
(function (KibanaSubjects) {
    KibanaSubjects["FetchLogs"] = "fetch-logs";
})(KibanaSubjects || (KibanaSubjects = {}));
export var KibanaAnalytics;
(function (KibanaAnalytics) {
    KibanaAnalytics["KibanaSearchAnalyticsKey"] = "kibana-search";
})(KibanaAnalytics || (KibanaAnalytics = {}));
export var KibanaSharedComponentsSubjects;
(function (KibanaSharedComponentsSubjects) {
    KibanaSharedComponentsSubjects["previewQueryInKibana"] = "preview-query-in-kibana";
})(KibanaSharedComponentsSubjects || (KibanaSharedComponentsSubjects = {}));
export var SearchTimeFrame;
(function (SearchTimeFrame) {
    SearchTimeFrame["48h"] = "48h";
    SearchTimeFrame["24h"] = "24h";
    SearchTimeFrame["12h"] = "12h";
    SearchTimeFrame["8h"] = "8h";
    SearchTimeFrame["4h"] = "4h";
    SearchTimeFrame["2h"] = "2h";
    SearchTimeFrame["1h"] = "1h";
    SearchTimeFrame["30m"] = "30m";
    SearchTimeFrame["15m"] = "15m";
})(SearchTimeFrame || (SearchTimeFrame = {}));
export const timeFrameInterval = {
    '48h': '30m',
    '24h': '15m',
    '12h': '10m',
    '8h': '5m',
    '4h': '3m',
    '2h': '2m',
    '1h': '2m',
    '30m': '1m',
    '15m': '1m',
};
export const timeFrameIntervalAsMinutes = {
    '48h': 30,
    '24h': 30,
    '12h': 15,
    '8h': 10,
    '4h': 5,
    '2h': 2,
    '1h': 2,
    '30m': 30,
    '15m': 15,
};
export const timeFrameAsHours = {
    '48h': 48,
    '24h': 24,
    '12h': 12,
    '8h': 8,
    '4h': 4,
    '2h': 2,
    '1h': 1,
    '30m': 0.5,
    '15m': 0.25,
};
//# sourceMappingURL=osd.enum.js.map